import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {InsoleMaterialDataService} from './insoleMaterial.data.service';
import {InsoleMaterialSummaryModel} from "../../../api/entity/insoleMaterialSummary.model";
import {InsoleMaterialSummaryConverter} from "../../../api/entity/insoleMaterialSummary.converter";
import {InsoleMaterialModel} from "../../../api/entity/insoleMaterial.model";

@Injectable()
export class InsoleMaterialSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    InsoleMaterialSummaryModel,
    InsoleMaterialSummaryConverter,
    InsoleMaterialModel> {
    constructor(dataService: InsoleMaterialDataService, converter: InsoleMaterialSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): InsoleMaterialModel {
        return new InsoleMaterialModel();
    }
}
